module.exports = "mutation personChangePublicUrl($personId: ID!, $url: String) {\n    personChangePublicUrl(personId: $personId, url: $url)\n}\n"